import styled from 'styled-components';

import RouterLink from '../../../../components/routerLink';

export const StyledRouterLink = styled(RouterLink)`
  color: ${({ theme }) => theme.palette.primary.main};
`;
